import { useEffect, useState } from 'react';
import ShoppingCartService from './services/shopping-cart.service';
import { useErrorBoundary } from 'basket/ErrorBoundary';
import InformationOverlay from './InformationOverlay';
import { formatCurrency} from 'utils/utils';

export function Headings({ headingsSmallView, headingsAll, headingId, setHeadingId, setEyeletSize, price, setHeadingHeightMin, setHeadingHeightMax, infoIcon }) {
    const handleError = useErrorBoundary();
    const [activeHeadingId, setActiveHeadingId] = useState(headingId);
    const [activeSubHeadingId, setActiveSubHeadingId] = useState(headingId);
    const [overlayVisible, setOverlayVisible] = useState(false);
    const [selectedHeadingDetails, setSelectedHeadingDetails] = useState(null);
    const [selectedDescription, setSelectedDescription] = useState(null);
    const [headingsPreview, setHeadingsPreview] = useState(headingsSmallView);

    useEffect(() => {
        const parentHeading = headingsAll.find(heading =>
            heading.subHeadings?.some(subheading => subheading.id === headingId)
        );
        if (parentHeading) {
            setActiveHeadingId(parentHeading.id);
            setEyeletSize(parentHeading.subHeadings?.find(subheading => subheading.id === headingId).name);
        }
    }, [headingId, headingsAll]);

    useEffect(() => {
        if (headingsSmallView && headingsSmallView.length > 0) {
            setHeadingsPreview(headingsSmallView);
        }
    }, [headingsSmallView]);    
    
    useEffect(() => {
        updatePreview();
    }, [activeSubHeadingId]);

    const handleHeadingClick = (headingId) => {
        if (headingId!=activeSubHeadingId){                
            setActiveHeadingId(headingId);
            setHeadingId(headingId);
            setActiveSubHeadingId(headingId);            

            const selectedHeading = headingsAll.find(heading => heading.id == headingId);
            setSelectedHeadingDetails(selectedHeading);
            setSelectedDescription(selectedHeading.description);
        }
    };

    const handleSubheadingChange = (subheadingId, size) => {
        setActiveSubHeadingId(subheadingId);
        setHeadingId(subheadingId);
        setEyeletSize(size);
    };

    const updateDescription = async () => {
        let selectedSubHeading = null;
    
        headingsAll.forEach(heading => {
            if (heading.subHeadings) {
                const subHeading = heading.subHeadings.find(sub => sub.id === activeSubHeadingId);
                if (subHeading) {
                    selectedSubHeading = subHeading;
                }
            }
        });
        
        if (selectedSubHeading){                
            setSelectedDescription(selectedSubHeading.description);
        }
    }

    const updatePreview = async () => {
        const { headingsSmallView, headingHeightLimitations } = await ShoppingCartService.create('options/1', {
            option: "headingsSmallView",
            headingId: activeSubHeadingId
        }).catch(error => { handleError('Could not load item details. Please contact administrator'); });
        if (headingsSmallView) setHeadingsPreview(headingsSmallView);
        if (headingHeightLimitations){
            setHeadingHeightMin(headingHeightLimitations.headingHeightMin);
            setHeadingHeightMax(headingHeightLimitations.headingHeightMax);
        }
        else {
            setHeadingHeightMin(null);
            setHeadingHeightMax(null);
        }
    }

    const toggleOverlay = () => {
        setOverlayVisible(!overlayVisible);
    };

    useEffect(() => {
        if (headingsAll?.length > 0 && activeHeadingId) {
            const selectedHeading = headingsAll.find(heading => heading.id == activeHeadingId);
            setSelectedHeadingDetails(selectedHeading);
        }
    }, [ headingsAll, activeHeadingId]);

    
    useEffect(() => {
        if (headingsAll?.length > 0 && activeSubHeadingId) {
            updateDescription();
        }
    }, [headingsAll, activeSubHeadingId]);

    const itemsPerRow = window.innerWidth > 768 ? 5 : 3;
    let selectedIndex = 1;
    let lastIndexInRow = window.innerWidth > 768 ? 4 : 2;
    if (headingsAll.length > 0 && activeHeadingId) {
        selectedIndex = headingsAll.findIndex(h => h.id === activeHeadingId);
        if (selectedIndex !== -1) {
            lastIndexInRow = Math.min(selectedIndex + itemsPerRow - (selectedIndex % itemsPerRow) - 1, headingsAll.length - 1);
        }
    }
    
    const isActiveHeading = (heading, activeHeadingId, activeSubHeadingId) => {
        if (heading.id === activeHeadingId || heading.id === activeSubHeadingId) {
            return true;
        }
    
        if (heading.subHeadings) {
            return heading.subHeadings.some(subheading => subheading.id === activeSubHeadingId);
        }
    
        return false;
    };    

    return (
        <div>
            <div className="body-text3 gray mt-16 mb-8 align-center gap_3">
                Heading: 
                {infoIcon && (
                    <InformationOverlay item={infoIcon} />
                )}
            </div>

            {/* Preview */}
            <div className="thumbnails thumbnails-5 have-first-el-active mb-16 headings-preview active-group">
                {headingsPreview && headingsPreview.length > 0 && headingsPreview.map((heading, index) => (
                    heading && (
                        <div
                            key={heading.id}
                            className={`choice-heading show-details ${isActiveHeading(heading, activeHeadingId, activeSubHeadingId) ? 'active' : ''} ${index>1 ? 'sm-no':''}`}
                            data-no-self-update="1"
                            onClick={() => handleHeadingClick(heading.id)}
                        >
                            <div className="thumbnail pointer mb_5 rel">
                                <img src={heading.imageUrl} alt={heading.name} />
                                <span className="curtains-icon curtains-icon-Check"></span>
                            </div>
                            <div className="body-text6 ps_5">{heading.name}</div>
                        </div>
                    )
                ))}

                <div className="thumbnail pointer underline p_5">
                    <div className="bg-white end-thumbnail show-overlay-btn" onClick={toggleOverlay}>
                        Show All
                    </div>
                </div>
            </div>

            <input 
                type="hidden" 
                name="headingId" 
                id="headingId" 
                value={activeSubHeadingId} 
            />

            {/* Overlay */}
            {overlayVisible && (
                <div className="overlay-with-box headings-overlay active-group mobile-menu d-flex" id="headings-overlay">
                    <div className="overlay-box mobile-menu-container sm-p-20">
                        <div className="row mb-12">
                            <div className="col">
                                <h3 className="sm-h4">Headings</h3>
                            </div>
                            <div className="col-auto">
                                <span className="curtains-icon curtains-icon-close size-24 pointer" onClick={toggleOverlay}></span>
                            </div>
                        </div>
                        <div className="body-text3 mb-32 sm-mb-40">Choose a heading style to suit your room.</div>
                        
                        <div className="thumbnails thumbnails-5 have-first-el-active mb-16 row-gap-32 sm-row-gap-24">
                            {headingsAll.map((heading, index) => (
                                index <= lastIndexInRow && (
                                <div key={heading.id}>
                                    <div
                                        className={`choice-heading show-details ${isActiveHeading(heading, activeHeadingId, activeSubHeadingId) ? 'active' : ''}`}
                                        onClick={() => handleHeadingClick(heading.id)}
                                    >
                                        <div className="thumbnail pointer mb_5 rel">
                                            <img src={heading.imageUrl} alt={heading.name} />
                                            <span className="curtains-icon curtains-icon-Check"></span>
                                        </div>
                                        <div className="body-text6 ps_5">{heading.name}</div>
                                    </div>
                                </div>)
                            ))}

                            {/* details row */}
                            {selectedHeadingDetails && (
                                <div className="heading-details-row px_5">
                                    <div className="row gap-32">
                                        <div className="col">
                                            <div className="body-text1">{price? formatCurrency(price) : formatCurrency(0)}</div>
                                            {selectedDescription ? (<div className="body-text6 max-width-310 mt-8">{selectedDescription}</div>) : ''}
                                        </div>
                                        <div className="col-auto sm-no">
                                            <button 
                                                className="d-flex btn justify-content-center align-items-center btn-secondary hide-overlay-btn width-210" 
                                                onClick={toggleOverlay}
                                                type="button"
                                            >
                                                Confirm
                                            </button>
                                        </div>
                                    </div>

                                    {selectedHeadingDetails.subHeadings && selectedHeadingDetails.subHeadings.length > 0 && (
                                        <div className="mt-12">
                                            <div className="body-text7 mb-8">{selectedHeadingDetails.subtitle}</div>
                                            <div className="d-flex gap-32 sm-column sm-gap-16">
                                                {selectedHeadingDetails.subHeadings.map(subheading => (
                                                    <div className="form-check" key={subheading.id}>
                                                        <input 
                                                            className="form-check-input choice-subheading" 
                                                            type="radio" 
                                                            id={`subheading-${subheading.id}`} 
                                                            name={`subheadings-${selectedHeadingDetails.id}`} 
                                                            value={subheading.id} 
                                                            checked={activeSubHeadingId == subheading.id} 
                                                            onChange={() => handleSubheadingChange(subheading.id,subheading.name)}
                                                        />
                                                        <label className="form-check-label" htmlFor={`subheading-${subheading.id}`}>
                                                            {subheading.name}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    <div className="sm-yes mt-16">
                                        <button 
                                            className="d-flex btn justify-content-center align-items-center btn-secondary hide-overlay-btn w-100" 
                                            onClick={toggleOverlay}
                                            type="button"
                                        >
                                            Confirm
                                        </button>
                                    </div>

                                    <div className="dashed-line mt-24"></div>
                                </div>
                            )}

                            {headingsAll.map((heading, index) => (
                                index > lastIndexInRow && (
                                <div key={heading.id}>
                                    <div
                                        className={`choice-heading show-details ${heading.id === activeHeadingId ? 'active' : ''}`}
                                        onClick={() => handleHeadingClick(heading.id)}
                                    >
                                        <div className="thumbnail pointer mb_5 rel">
                                            <img src={heading.imageUrl} alt={heading.name} />
                                            <span className="curtains-icon curtains-icon-Check"></span>
                                        </div>
                                        <div className="body-text6 ps_5">{heading.name}</div>
                                    </div>
                                </div>)
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
